import { useQueryClient } from '@tanstack/react-query';
import type { IxmUserauthV1SessionServiceWhoamiResponse, IxmUserauthV1UserPreferences } from '@interxfi/types/generated/api';
import { buildIxmUserauthV1SessionServiceWhoamiKey } from '../generated/hooks/ixm-userauth-v1-session-service-whoami';
import { useIxmUserauthV1UserCommandServiceSetUserPreferences } from '../generated/hooks/ixm-userauth-v1-user-command-service-set-user-preferences';

export function useSetUserPreferences() {
  const queryClient = useQueryClient();

  function optimisticUpdate(newPreferences: IxmUserauthV1UserPreferences | undefined) {
    if (newPreferences) {
      queryClient.setQueryData<IxmUserauthV1SessionServiceWhoamiResponse>(buildIxmUserauthV1SessionServiceWhoamiKey(), (existingData) => {
        if (!existingData?.user?.data) {
          return existingData;
        }

        return {
          ...existingData,
          user: {
            ...existingData.user,
            data: {
              ...existingData.user.data,
              preferences: {
                ...existingData.user.data.preferences,
                ...newPreferences,
              },
            },
          },
        };
      });
    }
  }

  return useIxmUserauthV1UserCommandServiceSetUserPreferences({
    onMutate: (variables) => optimisticUpdate(variables.preferences),
    onSuccess: (res) => optimisticUpdate(res?.preferences),
  });
}
